var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DefaultPanel",
    {
      staticClass: "tour-panel",
      attrs: { title: "Tour selezionato", selectable: "", "is-selected": true },
      scopedSlots: _vm._u([
        {
          key: "modal",
          fn: function() {
            return [
              _c("ModalTourDetail", {
                ref: "modalTourDetail",
                attrs: { value: _vm.value, hideForm: true }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-4" },
            [_c("small-carousel", { attrs: { images: _vm.images } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-8 right" }, [
            _c("div", [
              _c("div", { staticClass: "border-bottom pb-1" }, [
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c(
                    "h6",
                    { staticClass: "text-primary text-uppercase mb-0" },
                    [_vm._v(_vm._s(_vm.line))]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: require("../../../../assets/images/svg/black/icone_durata.svg"),
                        height: "18px"
                      }
                    }),
                    _vm._v(" "),
                    _c("b", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(_vm.period))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.name))])
              ]),
              _vm._v(" "),
              _vm.descrizione
                ? _c("div", { staticClass: "border-bottom pb-2" }, [
                    _c(
                      "div",
                      { staticStyle: { height: "35px", overflow: "hidden" } },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../../assets/images/svg/black/icone_lingua.svg"),
                            height: "12px"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-italic" }, [
                          _vm._v(_vm._s(_vm.descrizione))
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.groups, function(group, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "mb-2" }, [
                      _c("small", { staticClass: "text-uppercase" }, [
                        _vm._v("Camera " + _vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          staticClass: "form-control",
                          attrs: { index: index },
                          on: {
                            change: function(event) {
                              return _vm.onRoomChange(event, index)
                            }
                          }
                        },
                        _vm._l(group.prices, function(item, index2) {
                          return _c(
                            "option",
                            {
                              key: index2,
                              domProps: { selected: item.selected }
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(item.category) +
                                  _vm._s(
                                    index2
                                      ? ": + " +
                                          _vm.delta(
                                            group.prices,
                                            item.price.venditaTotaleEuro
                                          ) +
                                          "€"
                                      : ""
                                  ) +
                                  "\n                                    "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                !_vm.modified
                  ? _c(
                      "h6",
                      {
                        staticClass:
                          "text-primary default-bold text-uppercase position-relative mr-2",
                        staticStyle: { top: "7px" }
                      },
                      [_vm._v("selezionato")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary py-1",
                        on: { click: _vm.onConfirmPrice }
                      },
                      [_vm._v("Modifica")]
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "icon-circle-border-blue ml-1" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.onDetail }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../../assets/images/svg/blue/icone_dettagli.svg"),
                          width: "16px"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55216fcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55216fcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/tour-accompagnati/TourPanel.vue
// module id = null
// module chunks = 